var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.imageIsLocal)?_c('v-img',{style:(_vm.style),attrs:{"src":_vm.imageURL,"contain":"","title":_vm.imageTitle},on:{"error":function($event){_vm.imageURL=_vm.fallbackImage}}}):_c('v-img',{style:(_vm.style),attrs:{"src":_vm.fallbackImage,"contain":"","title":_vm.imageTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }